<div class="transparencia-section">

  <!-- TÍTULO -->
  <h2>TRANSPARENCIA INSTITUCIONAL</h2>
  <p class="busqueda">| Ctrl + F | PARA BUSCAR SU FRACCIÓN .</p>

  <!-- 🔥 TABS -->
  <div class="tabs-menu">

    <button [class.active]="tab==='art74'" (click)="setTab('art74')">
      ARTÍCULO 74
    </button>

    <button [class.active]="tab==='art75'" (click)="setTab('art75')">
      ARTÍCULO 75
    </button>

    <button [class.active]="tab==='iecr'" (click)="setTab('iecr')">
      IECR ITSE
    </button>

    <button [class.active]="tab==='irc'" (click)="setTab('irc')">
      IRC ITSE
    </button>

  </div>

  <!-- CONTENIDO -->
  <div class="tabs-content">

    <!-- ================= ARTICULO 74 ================= -->
    <div *ngIf="tab==='art74'">

      <div class="titulo-azul">ARTÍCULO 74.</div>

      <!-- PDF PRINCIPAL -->
      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/TABLA_DE_ACTUALIZACION_Y_CONSERVACION_ARTICULO_74_2018.pdf" target="_blank">
          Tabla Actualización y Conservación Art. 74 Descargar
        </a>
      </div>

      <hr>

      <!-- 🔥 FRACCIONES 74 -->
      <div class="fraccion-box" *ngFor="let f of fraccionesArt74">

        <div class="fraccion-header" (click)="toggleFraccion(f.num)">
          FRACCIÓN {{f.num}}.
        </div>

        <p class="fraccion-texto">
          {{f.texto}}
        </p>

        <div *ngIf="fraccionAbierta === f.num" class="fraccion-contenido">
          <iframe [src]="getSafeUrl(f.link)"></iframe>
        </div>

      </div>

      <!-- PDFs EXTRAS (SIN ARRAY) -->
      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/Tabla_de_aplicabilidad_Art_74-2022.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 74-2022
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/Tabla _de_Aplicabilidad_Art_74-2021.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 74-2021
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/Tabla_de_aplicabilidad_2020_ITSE.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 74-2020
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/Tabla_de_aplicabilidad_Art_74-2019.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 74-2019
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/TABLA_DE_APLICABILIDAD_2018.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 74-2018
        </a>
      </div>

    </div>

    <!-- ================= ARTICULO 75 ================= -->
    <div *ngIf="tab==='art75'">

      <div class="titulo-azul">ARTÍCULO 75.</div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/TABLA_DE_ACTUALIZACION_Y_CONSERVACION_ARTICULO_75.pdf" target="_blank">
          Tabla de Actualización y Conservación Art. 75
        </a>
      </div>

      <hr>

      <!-- 🔥 FRACCIONES 75 -->
      <div class="fraccion-box" *ngFor="let f of fraccionesArt75">

        <div class="fraccion-header" (click)="toggleFraccion(f.num)">
          FRACCIÓN {{f.num}}.
        </div>

        <p class="fraccion-texto">
          {{f.texto}}
        </p>

        <div *ngIf="fraccionAbierta === f.num" class="fraccion-contenido">
          <iframe [src]="getSafeUrl(f.link)"></iframe>
        </div>

      </div>

        <!-- PDFs EXTRAS (SIN ARRAY) -->
      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/Tabla_de_aplicabilidad_Art75-2022.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 75-2022
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/Tabla_de_Aplicabilidad_Art_75-2021.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 75-2021
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/Tabla_de_aplicabilidad_art752020_ITSE.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 75-2020
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/Tabla_de_aplicabilidad_Art_75-2019.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 75-2019
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/trasparencia/pdfs/TABLA_DE_APLICABILIDAD_2018_art75.pdf" target="_blank">
          Tabla de Aplicabilidad Art. 75-2018
        </a>
      </div>


    </div>

    <!-- ================= IECR ================= -->
    <div *ngIf="tab==='iecr'">
      <h3>IECR ITSE</h3>
      <br>

      <h4>2020</h4>
      <div class="pdf-item">
        <img src="assets/vinculacion/excel.png">
        <a href="assets/trasparencia/excel/IECR_ITSE_1er_Semestre_2020.xlsx" target="_blank">IECR ITSE PRIMER SEMESTRE 2020</a>
      </div>

        <h4>2019</h4>
      <div class="pdf-item">
        <img src="assets/vinculacion/excel.png">
        <a href="assets/trasparencia/excel/IECR_ITSE_PRIMER_SEMESTRE_2019.xlsx" target="_blank">IECR ITSE PRIMER SEMESTRE 2019</a>
      </div>
       <div class="pdf-item">
        <img src="assets/vinculacion/excel.png">
        <a href="assets/trasparencia/excel/IECR_2doSemestre_2019.xlsx" target="_blank">IECR ITSE SEGUNDO SEMESTRE 2019</a>
      </div>

        <h4>2018</h4>
      <div class="pdf-item">
        <img src="assets/vinculacion/excel.png">
        <a href="assets/trasparencia/excel/IECR_ITSE _er_Sem_2018.ods" target="_blank">IECR ITSE PRIMER SEMESTRE 2018</a>
      </div>
       <div class="pdf-item">
        <img src="assets/vinculacion/excel.png">
        <a href="assets/trasparencia/excel/IECR_ITSE_SEGUNDO_SEMESTRE_2018.xlsx" target="_blank">IECR ITSE SEGUNDO SEMESTRE 2018</a>
      </div>

          <h4>2017</h4>
      <div class="pdf-item">
        <img src="assets/vinculacion/excel.png">
        <a href="assets/trasparencia/excel/IERC_DEL_ITSE1.ods" target="_blank">IECR ITSE PRIMER SEMESTRE 2017</a>
      </div>
       <div class="pdf-item">
        <img src="assets/vinculacion/excel.png">
        <a href="assets/trasparencia/excel/IECR_2do_Sem_2017.xlsx" target="_blank">IECR ITSE SEGUNDO SEMESTRE 2017</a>
      </div>




    </div>

    <!-- ================= IRC ================= -->
    <div *ngIf="tab==='irc'">
      <h3>IRC ITSE</h3>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/rendicion_cuentas/ITSE-IRC-2025.pdf" target="_blank">
          ITSE-IRC-2025 
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/rendicion_cuentas/ITSE-IRC-2024.pdf" target="_blank">
          ITSE-IRC-2024 
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/rendicion_cuentas/ITSE-IRC-2023.pdf" target="_blank">
          ITSE-IRC-2023 
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/rendicion_cuentas/ITSE-IRC-2022.pdf" target="_blank">
          ITSE-IRC-2022 
        </a>
      </div>

       <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/rendicion_cuentas/ITSE-IRC-2021.pdf" target="_blank">
          ITSE-IRC-2021 
        </a>
      </div>

      <div class="pdf-item">
        <img src="assets/vinculacion/pdf.png">
        <a href="assets/rendicion_cuentas/ITSE-IRC-2020.pdf" target="_blank">
          ITSE-IRC-2020 
        </a>
      </div>
    </div>

  </div>

</div>